const DemoAccountDetails = () => {
  return (
    <div
      className="accountSettingsCard accountSettingsBigCard"
      key="Demo Upgrade Container"
    >
      <h3 className="accountSettingsCardTitle">Upgrade To Full Account</h3>
      <p className="accountSettingsToggleDescription">
        Upgrading to a full account unlocks unlimited access to our collection
        of over 150 cases!
      </p>
      <ol className="accountSettingsOrderedList">
        <li className="accountSettingsOrderedListNumber">1</li>
        <li className="accountSettingsOrderedListItem">
          <p>
            Click “Upgrade Now” or navigate to https://www.ccscases.com/purchase
          </p>
        </li>
        <li className="accountSettingsOrderedListNumber">2</li>
        <li className="accountSettingsOrderedListItem">
          <p>Select the amount of time that you need to study for your exam.</p>
        </li>
        <li className="accountSettingsOrderedListNumber">3</li>
        <li className="accountSettingsOrderedListItem">
          <p>
            At checkout, use the same e-mail address as this account and your
            account will be automatically upgraded from a demo to a full
            account.
          </p>
        </li>
      </ol>
      <a
        href="https://www.ccscases.com/purchase"
        rel="noopener noreferrer"
        target="_blank"
      >
        <button className="accountSettingsButton accountSettingsUpgradeButton">
          Upgrade Now
        </button>
      </a>
    </div>
  );
};

export default DemoAccountDetails;
